import React from 'react'
import { connect } from 'react-redux'
import { Row } from 'react-bootstrap'
import PropertyTitle from '../../../components/PropertyTitle'
import 'react-toggle/style.css'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../../messages'

import { updateUserFederatedIdentityId } from '../../../actions/user-actions'

class UpdateUserFederatedIdentityId extends React.Component {

    constructor() {
        super()
        this.state = {
            userId: undefined,
            newFederatedUserId: undefined,
            errorMessage: undefined
        }
    }

    componentDidMount() {
        if(this.props.userId) {
            this.setState({ userId: this.props.userId })
        }
    }

    componentWillUnmount() {
        this.setState({
            userId: undefined,
            newFederatedUserId: undefined,
            errorMessage: undefined
        })
    }

    search(query) {
        this.setState({query: query})
    }

    switch() {
        const data = {
            userId: this.state.userId,
            newFederatedIdentityId: this.state.newFederatedUserId
        }

        this.setState({ errorMessage: undefined })

        return this.props
            .updateUserFederatedIdentityId(data)
            .catch((err) => {
                const message =
                    (err && err.reason) ||
                    'Update failed.'

                this.setState({ errorMessage: message })
            })
    }

    onChangeUserId(e) {
        const value = e.target.value
        this.setState((prev) => ({
            userId: value,
            errorMessage: prev.errorMessage ? undefined : prev.errorMessage
        }))
    }

    onChangeFederatedUserId(e) {
        const value = e.target.value
        this.setState((prev) => ({
            newFederatedUserId: value,
            errorMessage: prev.errorMessage ? undefined : prev.errorMessage
        }))
    }

    render() {

        return <div className='content-changeUserId' >
            <Row className='dashboardRowContainer'>
                <PropertyTitle
                    icon='user'
                    text=" Gebruikersaccount wijzigen"
                />

                <Row style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}} >
                    <div >
                        <div style={{ padding:"5px",  marginBottom:"10px"}}>
                            Wijzig de provider user id in Boom Accounts voor kennisnet gebruikers
                        </div>
                    </div>

                    {this.state.errorMessage ? (
                        <div style={{ color: '#b00020', margin: '5px 0' }}>
                            {this.state.errorMessage}
                        </div>
                    ) : null}

                    <div>
                        <input
                            style={{marginTop:"5px" , borderColor:"#094FA3", width:"400px"}}
                            type="text"
                            placeholder="Boom Accounts User Id"
                            onChange={(e) => this.onChangeUserId(e)}
                        />
                    </div>
                    <div>
                        <input
                            style={{marginTop:"5px", borderColor:"#094FA3", width:"400px"}}
                            type="text"
                            placeholder="Nieuwe provider user Id"
                            onChange={(e) => this.onChangeFederatedUserId(e)}
                        />
                    </div>
                    <div>
                        <button
                            style={{marginTop:"10px", marginLeft:"0px"}}
                            className='button-dashboard'
                            onClick={() => this.switch()}
                        >
                            Update
                        </button>
                    </div>
                </Row>
            </Row>
        </div>
    }
}

let SearchInfo = () => (
    <div>
        <p>{SEARCH_INSTRUCTIONS}</p>
        <p>Zoek op:</p>
        <ul>
            <li>User ID</li>
        </ul>
        <p>{NO_SEARCH_RESULTS}</p>
    </div>
)

export default connect((state) => {
    return {
        results: state.dashboard.userLicenseSearchDashboard.results,
        query: state.dashboard.userLicenseSearchDashboard.query
    }}, {
    updateUserFederatedIdentityId,
})(UpdateUserFederatedIdentityId)